import styled from 'styled-components';

export const Details = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  borderRadius: '5px',
  padding: '0 20px',
  width: '450px',
  margin: '0px 20px',
  '@media only screen and (max-width: 1025px)': {
    margin: '15px 5px',
    padding: '0',
  },
});

export const Column = styled.div({ marginBottom: '20px' });
